import React from 'react';
import { cn } from '@/lib/utils';

export const EmptyState = ({ icon: Icon, title, description, action, className, testId = 'empty-state' }) => (
  <div
    className={cn('rounded-lg border border-dashed border-white/10 bg-[hsl(var(--surface-1))] p-8', className)}
    data-testid={testId}
  >
    <div className="flex items-start gap-4">
      {Icon && (
        <div className="flex h-10 w-10 items-center justify-center rounded-md border border-white/10 bg-[hsl(var(--surface-2))]">
          <Icon className="h-5 w-5 text-[hsl(var(--text-2))]" />
        </div>
      )}
      <div className="flex-1">
        <div className="text-sm font-medium">{title}</div>
        {description && <div className="mt-1 text-sm text-[hsl(var(--text-3))]">{description}</div>}
        {action && <div className="mt-4">{action}</div>}
      </div>
    </div>
  </div>
);
